const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- recipient-suggest ---
let __fez_component_0;
{
const FIELDS = ['to', 'cc', 'bcc', 'attendees']
const LIMIT = 8

/** The recipient being typed: the text between the separator before the caret and the next one. */
function currentToken(input) {
  const value = input.value
  const caret = input.selectionStart ?? value.length
  const start = Math.max(value.lastIndexOf(',', caret - 1), value.lastIndexOf(';', caret - 1)) + 1
  const next = value.slice(caret).search(/[,;]/)
  const end = next < 0 ? value.length : caret + next
  return { start, end, text: value.slice(start, caret).trim() }
}
__fez_component_0 = class {
  init() {
    this.state.items = []
    this.state.active = 0
    this.state.input = null
    this.state.seq = 0
    this.state.cache = {}
  }

  onMount() {
    const form = this.root.closest('form')
    if (!form) return
    this.on(form, 'input', (event) => this.isField(event.target) && this.lookup(event.target))
    this.on(form, 'keydown', (event) => this.isField(event.target) && this.onKey(event))
    this.on(form, 'focusout', (event) => this.isField(event.target) && this.setTimeout(() => this.state.input === event.target && document.activeElement !== event.target && this.close(), 120))
    this.on(window, 'resize', () => this.close())
  }

  isField(target) {
    return target?.tagName === 'INPUT' && FIELDS.includes(target.name)
  }

  lookup(input) {
    if (!this.globalState.me) return this.close()
    const token = currentToken(input)
    if (!token.text) return this.close()
    const seq = ++this.state.seq
    clearTimeout(this.state.timer)
    this.state.timer = this.setTimeout(() => this.fetch(input, token.text.toLowerCase(), seq), 120)
  }

  async fetch(input, q, seq) {
    let items = this.state.cache[q]
    if (!items) {
      try {
        const list = await window.App.api('contact/list', { q, limit: LIMIT }, { silent: true })
        items = list.items.flatMap((contact) => {
          const name = contact.name || ''
          const named = name.toLowerCase().includes(q)
          return contact.emails.filter((email) => named || email.includes(q)).map((address) => ({ address, name }))
        })
        this.state.cache = { ...this.state.cache, [q]: items }
      } catch {
        items = []
      }
    }
    if (seq !== this.state.seq || document.activeElement !== input) return
    const taken = new Set(input.value.split(/[,;]/).map((part) => part.trim().toLowerCase()))
    this.state.items = items.filter((item) => !taken.has(item.address)).slice(0, LIMIT)
    this.state.active = 0
    this.state.input = this.state.items.length ? input : null
    this.place()
  }

  // Under the field, inside the viewport; above it when there is no room below.
  place() {
    const menu = this.state.menu
    if (!menu) return
    if (!this.state.input) {
      if (menu.matches(':popover-open')) menu.hidePopover()
      return
    }
    const rect = this.state.input.getBoundingClientRect()
    menu.style.left = `${Math.round(rect.left)}px`
    menu.style.width = `${Math.round(Math.min(rect.width, 420))}px`
    if (!menu.matches(':popover-open')) menu.showPopover()
    const below = window.innerHeight - rect.bottom
    const top = below < menu.offsetHeight + 8 && rect.top > below ? rect.top - menu.offsetHeight - 4 : rect.bottom + 4
    menu.style.top = `${Math.round(top)}px`
  }

  afterRender() {
    this.place()
  }

  onKey(event) {
    if (!this.state.input || this.state.input !== event.target) return
    const count = this.state.items.length
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault()
      this.state.active = (this.state.active + (event.key === 'ArrowDown' ? 1 : count - 1)) % count
    } else if (event.key === 'Enter' || (event.key === 'Tab' && !event.shiftKey)) {
      event.preventDefault()
      this.pick(this.state.active)
    } else if (event.key === 'Escape') {
      // Close the list, not the compose window around it.
      event.preventDefault()
      event.stopPropagation()
      this.close()
    }
  }

  pick(index) {
    const input = this.state.input
    const item = this.state.items[index]
    if (!input || !item) return
    const { start, end } = currentToken(input)
    const before = input.value.slice(0, start)
    const after = input.value.slice(end).replace(/^[,;]\s*/, '')
    const inserted = `${before ? `${before.trimEnd()} ` : ''}${item.address}, `
    input.value = `${inserted}${after}`
    input.setSelectionRange(inserted.length, inserted.length)
    input.focus()
    this.close()
  }

  close() {
    this.state.seq++
    this.state.input = null
    this.state.items = []
  }

  beforeRender() {
    this.state.rows = this.state.items.map((item, index) => ({ ...item, index, active: index === this.state.active }))
  }

  CSS = `:fez {
display:contents;.suggest{position:fixed;inset:auto;margin:0;padding:var(--space-1);max-height:320px;overflow-y:auto;&:not(:popover-open){display:none}}.suggest-item{display:flex;align-items:center;gap:var(--space-2);width:100%;padding:var(--space-2);border:0;border-radius:var(--radius-md);background:transparent;color:var(--color-text);font:inherit;text-align:left;cursor:pointer;&:hover,&.active{background:var(--color-bg-hover)}}.suggest-text{display:grid;min-width:0;line-height:var(--leading-tight)}.suggest-name,.suggest-address{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.suggest-name{font-size:var(--text-sm);font-weight:var(--weight-medium)}.suggest-address{color:var(--color-text-muted);font-size:var(--text-xs)}
}`

  HTML = `<div class="suggest ui-card elevated" popover="manual" role="listbox" aria-label="Suggested recipients" fez:this="menu">
{#each state.rows as row}
<button type="button" class="suggest-item" class:active={row.active} role="option" aria-selected={row.active ? 'true' : 'false'} key={row.address} tabindex="-1" onmousedown="event.preventDefault()" onclick="fez.pick({row.index})">
<ui-avatar name={row.name || row.address} size="sm"></ui-avatar>
<span class="suggest-text">
{#if row.name}<span class="suggest-name">{row.name}</span>{/if}
<span class="suggest-address">{row.address}</span>
</span>
</button>
{/each}
</div>`
};
}

Fez('recipient-suggest', __fez_component_0);

export default __fez_component_0;
